import BSJA6BD1DPositioningModal from './BSJ_A6BD_1D_positioning-modal.vue'
export default BSJA6BD1DPositioningModal
